export const config = {
  API_URL: 'https://backend.surveyberry.ai/api/',
};
